<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Детали шаблона квитанции
      <router-link class="btn btn-primary" :to="{ name: 'bill-template-edit', params: { id: bill_template.id }}">Редактировать информацию</router-link>
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'bill-templates' }">← Назад к Шаблонам квитанций</router-link>
    </div>

    <h4>Доступные переменные</h4>
    <p>
      <strong>{contract_number}</strong> &ndash; номер договора<br>
      <strong>{debp}</strong> &ndash; сумма долга<br>
      <strong>{apartment}</strong> &ndash; номер квартиры<br>
      <strong>{block}</strong> &ndash; номер подъезда<br>
      <strong>{building}</strong> &ndash; номер дома<br>
      <strong>{street}</strong> &ndash; улица<br>
      <strong>{district}</strong> &ndash; район<br>
      <strong>{city}</strong> &ndash; город<br>
    </p>

    <div class="row">
      <div class="col-md-6">

        <!-- Name -->
        <div class="form-group">
          <label>Название</label>
          <p>{{ bill_template.file }}</p>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { getBillTemplate } from '@/services/bill_template.service'
import helpers from '@/helpers'

export default {
  name: 'bill-template-details',
  data () {
    return {
      bill_template: {
        id: null,
        file: ''
      }
    }
  },
  mounted () {
    if (this.$route.params.id !== undefined) {
      this.bill_template.id = this.$route.params.id

      getBillTemplate(this.bill_template.id).then((response) => {
        this.bill_template = response.data
      })
    }
  },
  methods: {
    formatDate: helpers.formatDate,
    toMoney: helpers.toMoney
  }
}
</script>


// WEBPACK FOOTER //
// BillTemplateDetails.vue?9ab70d48